import * as types from './mutation-types'

export default {
  [types.ADD_ORDERS](state, data) {
    state.orders = data.data
  },
  [types.ADD_ORDER](state, data) {
    state.orders.push(data)
  },
  [types.LOAD_ORDER_STATUS](state, data) {
    state.orderStatus = data.data
  },
  [types.SET_CURRENT_ORDER](state, data) {
    state.currentOrder = data
  },
  [types.UPDATE_ORDER](state, data) {
    state.currentOrder = data
  }
}
